export default function VirtualSportsCategory() {
  return <div className='mt-5 md:mt-0'>VirtualSportsCategory Component</div>
}
